import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, createBlock as _createBlock, unref as _unref, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "light-text" }
const _hoisted_2 = { class: "row no-space justify-between items-end" }
const _hoisted_3 = { class: "col-8 no-space" }
const _hoisted_4 = { class: "light-text" }
const _hoisted_5 = { class: "row no-space justify-between items-end" }
const _hoisted_6 = { class: "col-8-small" }
const _hoisted_7 = { class: "no-space" }
const _hoisted_8 = { class: "text-right" }
const _hoisted_9 = {
  key: 1,
  disabled: ""
}
const _hoisted_10 = { class: "row no-space justify-between items-end" }
const _hoisted_11 = { class: "col-8" }
const _hoisted_12 = { class: "light-text" }
const _hoisted_13 = { class: "no-space" }
const _hoisted_14 = { class: "text-right" }
const _hoisted_15 = { class: "row no-space justify-between items-end" }
const _hoisted_16 = { class: "col-6-large" }
const _hoisted_17 = { class: "light-text" }
const _hoisted_18 = { class: "no-space" }
const _hoisted_19 = { class: "row no-space justify-between items-end" }
const _hoisted_20 = { class: "col-7" }
const _hoisted_21 = { class: "light-text" }
const _hoisted_22 = { class: "no-space" }
const _hoisted_23 = { class: "text-right" }
const _hoisted_24 = { class: "col-9" }
const _hoisted_25 = { class: "light-text" }
const _hoisted_26 = { class: "text-right" }
const _hoisted_27 = ["href"]
const _hoisted_28 = { class: "row no-space justify-between items-end" }
const _hoisted_29 = { class: "col-8-small" }
const _hoisted_30 = { class: "light-text" }
const _hoisted_31 = { class: "no-space" }
const _hoisted_32 = { class: "text-right" }
const _hoisted_33 = {
  key: 1,
  disabled: ""
}

import { ref, computed } from 'vue'
import { useStore } from 'vuex'
import { KycStatus } from '@/constants'
import Icon from '@/components/CommonUI/Icon.vue'
import LoaderErrorBlock from '@/components/CommonUI/LoaderErrorBlock.vue'
import Notification from '@/components/CommonUI/Notification.vue'
import VerifyMeButton from '@/components/VerifyMeButton.vue'
import { getErrorMessage } from '@/helpers/errorHandler'

const whySuspendedLink = 'https://support.dittomusic.com/en/articles/4283888-why-has-my-account-been-suspended#'
const panelsClass = 'verification panel elevate'


export default /*@__PURE__*/_defineComponent({
  __name: 'VerificationPanel',
  emits: ['verification-updated'],
  setup(__props) {



const store = useStore()

const dashboardUrl = process.env.VUE_APP_DASHBOARD_URL || ''
const kycStatus = KycStatus
const payoutEmailResent = ref(false)
const userEmailResent = ref(false)
const emailResentError = ref<string | null>(null)

const userKycStatus = computed(() => store.state.user.status?.kyc)
const hasSubscriptionError = computed(() => store.state.hasSubscriptionError)

const isSubscriptionMissing = computed(() => store.getters.isSubscriptionMissing)
const isSuspended = computed(() => store.getters.isSuspended)
const isUserEmailVerified = computed(() => store.getters.isUserEmailVerified)
const unverifiedActivePayoutMethods = computed(() => store.getters.unverifiedActivePayoutMethods)

async function resendUserEmail() {
  try {
    emailResentError.value = null
    await store.dispatch('resendUserVerificationEmail')
    userEmailResent.value = true
  } catch (error) {
    emailResentError.value = getErrorMessage(error)
  }
}

async function resendPayoutEmail(payoutMethodId: number) {
  try {
    emailResentError.value = null
    await store.dispatch('resendPayoutVerificationEmail', payoutMethodId)
    payoutEmailResent.value = true
  } catch (error) {
    emailResentError.value = getErrorMessage(error)
  }
}

return (_ctx: any,_cache: any) => {
  const _directive_translate = _resolveDirective("translate")!

  return (isSuspended.value)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: _normalizeClass(["error", panelsClass])
      }, [
        _createElementVNode("h2", _hoisted_1, [
          _createVNode(Icon, {
            name: "forbidden",
            fill: "white",
            class: "pull-right"
          }),
          _withDirectives((_openBlock(), _createElementBlock("span", null, [...(_cache[2] || (_cache[2] = [
            _createTextVNode("Payouts are ", -1),
            _createElementVNode("strong", null, "not available", -1),
            _createTextVNode(" while your account is ", -1),
            _createElementVNode("strong", null, "suspended", -1),
            _createTextVNode(".", -1)
          ]))])), [
            [_directive_translate]
          ])
        ]),
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("p", _hoisted_3, [
            _withDirectives((_openBlock(), _createElementBlock("span", null, [...(_cache[3] || (_cache[3] = [
              _createTextVNode("If you'd like to appeal your suspension, please contact", -1)
            ]))])), [
              [_directive_translate]
            ]),
            _cache[4] || (_cache[4] = _createTextVNode("  ", -1)),
            _cache[5] || (_cache[5] = _createElementVNode("a", {
              href: "mailto:investigations@dittomusic.com",
              class: "text-white"
            }, "investigations@dittomusic.com", -1))
          ]),
          _withDirectives((_openBlock(), _createElementBlock("a", {
            href: whySuspendedLink,
            target: "_blank",
            class: "faded-link"
          }, [...(_cache[6] || (_cache[6] = [
            _createTextVNode(" Why we suspend accounts ", -1)
          ]))])), [
            [_directive_translate]
          ])
        ])
      ]))
    : (!isUserEmailVerified.value)
      ? (_openBlock(), _createElementBlock("div", {
          key: 1,
          class: _normalizeClass(["warning", panelsClass])
        }, [
          _withDirectives((_openBlock(), _createElementBlock("h2", _hoisted_4, [...(_cache[7] || (_cache[7] = [
            _createTextVNode(" Please confirm your ", -1),
            _createElementVNode("strong", null, "email address.", -1)
          ]))])), [
            [_directive_translate]
          ]),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _withDirectives((_openBlock(), _createElementBlock("p", _hoisted_7, [...(_cache[8] || (_cache[8] = [
                _createTextVNode(" We've sent you an email to confirm your address. Click the link in the email and come back to set up your payout method. ", -1)
              ]))])), [
                [_directive_translate]
              ]),
              (emailResentError.value)
                ? (_openBlock(), _createBlock(Notification, {
                    key: 0,
                    type: "error",
                    "icon-name": "danger",
                    "icon-fill": "white",
                    title: _ctx.$gettext('An error occurred, please try again'),
                    message: emailResentError.value
                  }, null, 8, ["title", "message"]))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_8, [
              (!userEmailResent.value)
                ? _withDirectives((_openBlock(), _createElementBlock("button", {
                    key: 0,
                    class: "white",
                    onClick: resendUserEmail
                  }, [...(_cache[9] || (_cache[9] = [
                    _createTextVNode(" Resend email ", -1)
                  ]))])), [
                    [_directive_translate]
                  ])
                : _withDirectives((_openBlock(), _createElementBlock("button", _hoisted_9, [...(_cache[10] || (_cache[10] = [
                    _createTextVNode(" Email resent ", -1)
                  ]))])), [
                    [_directive_translate]
                  ])
            ])
          ])
        ]))
      : (userKycStatus.value === _unref(kycStatus).required)
        ? (_openBlock(), _createElementBlock("div", {
            key: 2,
            class: _normalizeClass(["primary", panelsClass])
          }, [
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("div", _hoisted_11, [
                _withDirectives((_openBlock(), _createElementBlock("h2", _hoisted_12, [...(_cache[11] || (_cache[11] = [
                  _createTextVNode(" We just need to ", -1),
                  _createElementVNode("strong", null, "confirm your identity", -1),
                  _createTextVNode(". ", -1)
                ]))])), [
                  [_directive_translate]
                ]),
                _createElementVNode("p", _hoisted_13, _toDisplayString(_ctx.$gettext("Please complete this quick, one-time identity check. It'll only take a few minutes and once you're verified we can start sending royalties!")), 1)
              ]),
              _createElementVNode("div", _hoisted_14, [
                _createVNode(VerifyMeButton)
              ])
            ])
          ]))
        : (userKycStatus.value === _unref(kycStatus).inProgress)
          ? (_openBlock(), _createElementBlock("div", {
              key: 3,
              class: _normalizeClass(["warning", panelsClass])
            }, [
              _createElementVNode("div", _hoisted_15, [
                _createElementVNode("div", _hoisted_16, [
                  _withDirectives((_openBlock(), _createElementBlock("h2", _hoisted_17, [...(_cache[12] || (_cache[12] = [
                    _createTextVNode(" Your identity check is ", -1),
                    _createElementVNode("strong", null, "in progress…", -1),
                    _createTextVNode(". ", -1)
                  ]))])), [
                    [_directive_translate]
                  ]),
                  _withDirectives((_openBlock(), _createElementBlock("p", _hoisted_18, [...(_cache[13] || (_cache[13] = [
                    _createTextVNode(" It will only take a few minutes. You may need to refresh this page. ", -1)
                  ]))])), [
                    [_directive_translate]
                  ])
                ])
              ])
            ]))
          : (userKycStatus.value === _unref(kycStatus).rejected)
            ? (_openBlock(), _createElementBlock("div", {
                key: 4,
                class: _normalizeClass(["error", panelsClass])
              }, [
                _createElementVNode("div", _hoisted_19, [
                  _createElementVNode("div", _hoisted_20, [
                    _withDirectives((_openBlock(), _createElementBlock("h2", _hoisted_21, [...(_cache[14] || (_cache[14] = [
                      _createTextVNode(" Your identity check was ", -1),
                      _createElementVNode("strong", null, "unsuccessful", -1),
                      _createTextVNode(". ", -1)
                    ]))])), [
                      [_directive_translate]
                    ]),
                    _withDirectives((_openBlock(), _createElementBlock("p", _hoisted_22, [...(_cache[15] || (_cache[15] = [
                      _createTextVNode(" Please try again, or check our FAQs for help on how to verify your account. ", -1)
                    ]))])), [
                      [_directive_translate]
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_23, [
                    _createVNode(VerifyMeButton, {
                      onFinishedSdk: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('verification-updated')))
                    })
                  ])
                ])
              ]))
            : (hasSubscriptionError.value)
              ? (_openBlock(), _createBlock(LoaderErrorBlock, {
                  key: 5,
                  "error-title": _ctx.$gettext('Oops! We couldn’t load this right now.'),
                  "error-message": _ctx.$gettext('Please refresh the page or try again later.')
                }, null, 8, ["error-title", "error-message"]))
              : (isSubscriptionMissing.value)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 6,
                    class: _normalizeClass(["warning", panelsClass])
                  }, [
                    _createElementVNode("div", _hoisted_24, [
                      _withDirectives((_openBlock(), _createElementBlock("h2", _hoisted_25, [...(_cache[16] || (_cache[16] = [
                        _createTextVNode(" You need an ", -1),
                        _createElementVNode("strong", null, "active subscription", -1),
                        _createTextVNode(" to make payout requests. ", -1)
                      ]))])), [
                        [_directive_translate]
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_26, [
                      _withDirectives((_openBlock(), _createElementBlock("a", {
                        href: `${_unref(dashboardUrl)}/subscriptions`,
                        class: "button white pull-right"
                      }, [...(_cache[17] || (_cache[17] = [
                        _createTextVNode("Pick a plan", -1)
                      ]))], 8, _hoisted_27)), [
                        [_directive_translate]
                      ])
                    ])
                  ]))
                : (unverifiedActivePayoutMethods.value.length)
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 7,
                      class: _normalizeClass(["warning", panelsClass])
                    }, [
                      _createElementVNode("div", _hoisted_28, [
                        _createElementVNode("div", _hoisted_29, [
                          _createElementVNode("h2", _hoisted_30, [
                            _createTextVNode(_toDisplayString(_ctx.$gettext('We\'ve emailed you to confirm your new')) + " ", 1),
                            _createElementVNode("strong", null, _toDisplayString(unverifiedActivePayoutMethods.value[0].name), 1),
                            _createTextVNode(" " + _toDisplayString(_ctx.$gettext('payout method.')), 1)
                          ]),
                          _withDirectives((_openBlock(), _createElementBlock("p", _hoisted_31, [...(_cache[18] || (_cache[18] = [
                            _createTextVNode(" Make sure to check your spam folder. If it hasn’t arrived, try resending the email. ", -1)
                          ]))])), [
                            [_directive_translate]
                          ]),
                          (emailResentError.value)
                            ? (_openBlock(), _createBlock(Notification, {
                                key: 0,
                                type: "error",
                                "icon-name": "danger",
                                "icon-fill": "white",
                                title: _ctx.$gettext('An error occurred, please try again'),
                                message: emailResentError.value
                              }, null, 8, ["title", "message"]))
                            : _createCommentVNode("", true)
                        ]),
                        _createElementVNode("div", _hoisted_32, [
                          (!payoutEmailResent.value)
                            ? _withDirectives((_openBlock(), _createElementBlock("button", {
                                key: 0,
                                class: "white",
                                onClick: _cache[1] || (_cache[1] = ($event: any) => (resendPayoutEmail(unverifiedActivePayoutMethods.value[0].id)))
                              }, [...(_cache[19] || (_cache[19] = [
                                _createTextVNode(" Resend email ", -1)
                              ]))])), [
                                [_directive_translate]
                              ])
                            : _withDirectives((_openBlock(), _createElementBlock("button", _hoisted_33, [...(_cache[20] || (_cache[20] = [
                                _createTextVNode(" Email resent ", -1)
                              ]))])), [
                                [_directive_translate]
                              ])
                        ])
                      ])
                    ]))
                  : _createCommentVNode("", true)
}
}

})